import { useAuth } from '@/hooks/useAuth'

// const userRole = "SUPER_ADMIN"

const hasPermission = ({ _permissions, scopes }) => {
  const scopesMap = {}
  scopes.forEach((scope) => {
    scopesMap[scope] = true
  })
  return _permissions.some((permission) => scopesMap[permission])
}

export const isAuthorized = (activeViews, scopes = []) => {
  // let _permissions = Permissions[userRole];

  if (!activeViews || !activeViews.scope) {
    return false
  }

  const currentRoleScope = activeViews
  const _permissions = currentRoleScope.scope
  return hasPermission({ _permissions, scopes })
}

export function Auth({ children, scopes = [] }) {
  const { activeViews } = useAuth()

  if (!activeViews || activeViews === null) {
    return null
  }
  const currentRoleScope = activeViews
  const _permissions = currentRoleScope.scope
  /* if(currentRoleScope['role']==appRoles['Superadmin']) {
    Array.prototype.push.apply(scopes,currentRoleScope['scope'])
  } */
  const permissionGranted = hasPermission({ _permissions, scopes })
  if (!permissionGranted) {
    return null
  }
  return children
}
